import {
  createRoute,
  RequiredStringParam,
  StringParam,
} from 'react-router-url-params';

export const Links: { [key: string]: any } = {
  Unauthorized: {
    Login: createRoute('/login'),
    Contacts: createRoute('/contacts'),
    ResetPassword: createRoute('/reset-password'),
    ForgotPassword: createRoute('/forgot-password'),
  },
  Authorized: {
    Dashboard: createRoute('/'),
    Druckdaten: createRoute('/print-data'),
    UiKit: createRoute('/uikit'),
    FirmwareOld: createRoute('/old-firmware'),
    Articles: createRoute('/articles'),
    DeliveryObligation: createRoute('/delivery-obligation'),
    PlanChart: createRoute('/articles/plan-chart', undefined, {
      product: RequiredStringParam,
      warehouseGroup: StringParam,
    }),
    Welcome: createRoute('/'),
    Admin: createRoute('/admin'),
    CustomPages: {
      DesignerRoot: createRoute('/page-designer'),
      DesignerNewPage: createRoute('/page-designer/:url', {
        url: RequiredStringParam,
      }),
      DesignerSinglePage: createRoute('/page-designer/:url', {
        url: RequiredStringParam,
      }),
      SinglePage: createRoute('/:url', {
        url: RequiredStringParam,
      }),
    },
    WarrantyRequest: createRoute('/create-warranty-request'),
    WarrantyInfo: createRoute('/create-warranty-request/warranty-info'),
    WarrantyRequestHistory: createRoute('/warranty-request-history'),
    Qualifications: createRoute('/qualifications'),
    DeviceOverview: createRoute('/device-overview'),
    UserManagement: createRoute('/user-management'),
    OrderList: createRoute('/order-list'),
    OutstandingReceivables: createRoute('/outstanding-receivables'),
    Repairs: createRoute('/repairs'),
    CreateRepairRequest: createRoute('/repairs/create'),
    DetailedRepairs: createRoute('/repairs/:incomingNumber', {
      incomingNumber: RequiredStringParam,
    }),
    ServiceAndRepair: createRoute('/service-and-repair'),
    TelehealthBilling: createRoute('/telehealth-billing'),
    ServicePresentation: createRoute('/service-presentation'),
    PriceLists: createRoute('/price-lists'),
    TechUpdates: createRoute('/tech-updates'),
    SNLots: createRoute('/serial-number'),
    SettingsAndUse: createRoute('/settings-and-use'),
    Firmware: createRoute('/firmware'),
    Software: createRoute('/software'),
    AbasDocuments: createRoute('/abas-documents'),
    MainboardReplacerForm: createRoute('/mainboard-replacer'),
    CertificateInstruction: createRoute('/mainboard-replacer/instruction'),
    AdvancedSearch: createRoute('/advanced-search'),
    AccountSettings: createRoute('/account-settings'),
  },
};
